import { HttpErrorResponse } from '@angular/common/http';
import { createFeature, createReducer, on } from '@ngrx/store';
import { SavingsPlanTeaserProduct } from '../entities/savings-plan-teaser-product.entity';
import { savingsPlanTeaserProducts } from '../infrastructure/savings-plan-teaser-products';
import { DepotActions, DepotApiActions } from './depot.actions';

export const DEPOT_FEATURE_KEY = 'depot';

interface DepotState {
  loading: boolean;
  error: HttpErrorResponse | null;
  teaserProducts: SavingsPlanTeaserProduct[];
  teaserProductsIgnoreInterest: SavingsPlanTeaserProduct[];
  displayDirectDebitHint: boolean;
  dividendReinvestHint: boolean;
  dividendReceivedHint: boolean;
  firstActionStrategyHint: boolean;
}

export interface DepotStateState {
  readonly [DEPOT_FEATURE_KEY]: DepotState;
}

const initialState: DepotState = {
  loading: false,
  error: null,
  teaserProducts: null,
  teaserProductsIgnoreInterest: null,
  displayDirectDebitHint: false,
  dividendReinvestHint: false,
  dividendReceivedHint: false,
  firstActionStrategyHint: false,
};

export const depotFeature = createFeature({
  name: DEPOT_FEATURE_KEY,
  reducer: createReducer(
    initialState,
    on(DepotActions.loadUserInterests, (state): DepotState => ({ ...state, error: null, loading: true })),
    on(
      DepotApiActions.loadUserInterestsSuccess,
      (state, { userInterests }): DepotState => ({
        ...state,
        loading: false,
        teaserProducts: userInterests.savingplan_interested ? savingsPlanTeaserProducts : [],
        teaserProductsIgnoreInterest: savingsPlanTeaserProducts,
        displayDirectDebitHint: userInterests.savingplan_direct_debit_hint,
        dividendReinvestHint: userInterests.dividend_reinvest,
        dividendReceivedHint: userInterests.dividend_received_reinvest_hint,
        firstActionStrategyHint: userInterests.first_action_strategy_hint,
      }),
    ),
    on(DepotApiActions.loadUserInterestsFailure, (state, { error }): DepotState => ({ ...state, error, loading: false })),
    on(DepotActions.dismissSavingsPlanTeaser, (state): DepotState => ({ ...state })),
    on(DepotApiActions.dismissSavingsPlanTeaserSuccess, (state): DepotState => ({ ...state, error: null, teaserProducts: null })),
    on(DepotApiActions.dismissSavingsPlanTeaserFailure, (state, { error }): DepotState => ({ ...state, error })),
    on(DepotApiActions.activateDirectDebitSuccess, (state): DepotState => ({ ...state, displayDirectDebitHint: false })),
  ),
});
